
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/ModalWindow.vue'
import LabelBase from '@/components/atoms/LabelBase.vue'
import InputText from '@/components/molecules/InputText.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import { AvatarCode } from '@/const/AvatarCode'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'

/**
 * ユーザ情報編集モーダルのフォーマット
 */
@Component({
  components: {
    ModalWindow,
    LabelBase,
    InputText,
    ImageBase,
    ButtonSubmit,
  },
})
export default class ModalUserData extends Vue {
  /** モーダル分子 */
  @Ref()
  modalWindow!: ModalWindow

  /** 確認ボタン押下時のイベント */
  @Prop()
  private eventSubmit!: (nickname: string, iconCode: string) => Promise<void>

  /** アイコン画像のリスト */
  @Prop()
  private avatarList!: AvatarCode.AvatarMaster[]

  /** ニックネーム */
  private nickname: string = ''

  /** アイコン画像コード */
  private iconCode: string = ''

  /**
   * モーダルを開く
   *
   * @param nickname ニックネーム
   * @param iconCode アイコン画像コード
   */
  public show(nickname: string, iconCode: string | null): void {
    this.nickname = nickname
    // アイコン未設定(null)の場合、未設定用のコードを代入する
    this.iconCode = iconCode || AvatarCode.AVATAR_NONE.code
    this.modalWindow.show()
  }

  /**
   * モーダルを閉じる
   */
  public hide(): void {
    this.modalWindow.hide()
  }
}
